const gtmId = 'GTM-KTS6LXWX';

const gtmScript = `
(
  function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event:'gtm.js'
    });
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),
    dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    // f.parentNode.insertBefore(j,f);
    d.head.appendChild(j);
  })(window,document,'script','dataLayer','${gtmId}'
);
`;

const gtmNoScript = `
<iframe
  src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
  height="0"
  width="0"
  style="display:none;visibility:hidden"
>
</iframe>
`;

// Abandoned method.
// Reason: in CSP, script-src is not allowed to use 'unsafe-inline', so we need to insert the script manually.
export const insertGTMScript = () => {
  const script = document.createElement('script');
  script.innerHTML = gtmScript;
  document.head.appendChild(script);

  const noScript = document.createElement('noscript');
  noScript.innerHTML = gtmNoScript;
  const body = document.body;
  const firstChildInBody = body.firstChild;
  body.insertBefore(noScript, firstChildInBody);
};

/**
 * Push a virtual page_view event to the GTM dataLayer.
 *
 * Required for single-page-app navigation: the GTM container only auto-fires a
 * page view on the initial hard load, so every client-side route change must
 * push its own page_view for Google Analytics to count it.
 */
export const pushPageView = (pagePath: string) => {
  // @ts-expect-error window.dataLayer is not defined in the window object
  window.dataLayer = window.dataLayer || [];
  // @ts-expect-error dataLayer is not defined in the window object
  window.dataLayer.push({
    event: 'page_view',
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const installGTM = () => {
  // @ts-expect-error window.dataLayer is not defined in the window object
  window.dataLayer = window.dataLayer || [];
  // @ts-expect-error dataLayer is not defined in the window object
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  // script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  // noscript iframe
  const noScript = document.createElement('noscript');

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';

  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';

  noScript.appendChild(iframe);

  document.body.insertBefore(noScript, document.body.firstChild);
};
